import deviceTagsTemplate from './deviceTags.html';
import './deviceTags.scss';

export default angular
  .module('main.devices.edit.components.tags', [])

  .directive('editDeviceTags', () => {
    return {
      restrict: 'E',
      template: deviceTagsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceLocationResource.init()
          ])
            .then(() => {
              $scope.loading = false;
            });

          $scope.$on('deleteTagsCompleteEvent', function(event, data) {
            event.preventDefault();
          });
          $scope.$on('addTagsCompleteEvent', function(event, data) {
            event.preventDefault();
          });
        }
      }
    };
  })
  .name;
